"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.selectLinkTarget = exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _format = _interopRequireDefault(require("date-fns/format"));
var _isDate = _interopRequireDefault(require("date-fns/isDate"));
var _parseISO = _interopRequireDefault(require("date-fns/parseISO"));
var _styledComponents = require("styled-components");
var _constants = require("../../constants");
var _notifications = require("../../constants/notifications");
var _styles = require("./styles");
var _Success = _interopRequireDefault(require("./icons/Success"));
var _Warning = _interopRequireDefault(require("./icons/Warning"));
var _Error = _interopRequireDefault(require("./icons/Error"));
var _Info = _interopRequireDefault(require("./icons/Info"));
var _Debug = _interopRequireDefault(require("./icons/Debug"));
var _types = require("./types");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const selectActionIcon = status => {
  switch (status) {
    case false:
      return _react.default.createElement(_styles.ReadBtn, null);
    case true:
      return null;
    default:
      return _react.default.createElement(_styles.CloseBtn, null);
  }
};
const selectIcon = category => {
  switch (category) {
    case _notifications.CATEGORIES.SUCCESS:
      return _Success.default;
    case _notifications.CATEGORIES.WARNING:
      return _Warning.default;
    case _notifications.CATEGORIES.CRITICAL:
      return _Error.default;
    case _notifications.CATEGORIES.ERROR:
      return _Error.default;
    case _notifications.CATEGORIES.INFO:
      return _Info.default;
    case _notifications.CATEGORIES.DEBUG:
      return _Debug.default;
    default:
      return _Info.default;
  }
};
const selectLinkTarget = target => {
  if (typeof target === 'string') {
    return target.toLocaleLowerCase() === 'true';
  }
  return !!target;
};
exports.selectLinkTarget = selectLinkTarget;
class Snack extends _react.PureComponent {
  constructor(...args) {
    super(...args);
    this.state = {
      isFadeIn: false,
      isFadeOut: false
    };
    this.selectActionTitle = status => {
      switch (status) {
        case false:
          return this.props.localeData.notificationRead;
        case true:
          return '';
        default:
          return this.props.localeData.notificationDismiss;
      }
    };
    this.selectColor = (category, status) => {
      const {
        theme
      } = this.props;
      if (status) return 'transparent';
      switch (category) {
        case _notifications.CATEGORIES.CRITICAL:
          return theme.colors.appFrame.snack.categories.critical;
        case _notifications.CATEGORIES.ERROR:
          return theme.colors.appFrame.snack.categories.error;
        case _notifications.CATEGORIES.WARNING:
          return theme.colors.appFrame.snack.categories.warning;
        case _notifications.CATEGORIES.SUCCESS:
          return theme.colors.appFrame.snack.categories.success;
        case _notifications.CATEGORIES.INFO:
          return theme.colors.appFrame.snack.categories.info;
        case _notifications.CATEGORIES.DEBUG:
          return theme.colors.appFrame.snack.categories.default;
        default:
          return theme.colors.appFrame.snack.categories.default;
      }
    };
    this.hideAndRead = callback => {
      this.props.onHide({
        notification: this.props.notification,
        conflictMsg: this.props.localeData.notificationAlreadyRead,
        callback
      });
    };
    this.hide = () => {
      if (this.props.notification.isRead === false) {
        this.hideAndRead();
      } else {
        this.props.onHide({
          notification: this.props.notification
        });
      }
    };
  }
  componentDidMount() {
    this.setState({
      isFadeIn: this.props.isFadeIn
    });
  }
  componentDidUpdate(prevProps) {
    if (prevProps.notification.delay !== this.props.notification.delay && this.props.notification.delay === -1) {
      this.hideAndRead();
    }
    if (this.props.isFadeOut) {
      this.setState({
        isFadeOut: true
      });
    }
  }
  render() {
    const {
      theme,
      notification,
      isFadeIn,
      onMouseLeave,
      onMouseEnter
    } = this.props;
    const IconComponent = selectIcon(notification.category);
    return _react.default.createElement(_styles.SnackWrapper, {
      visible: !isFadeIn,
      fadeIn: this.state.isFadeIn,
      fadeOut: this.state.isFadeOut,
      unread: notification.isRead === false,
      "data-test-id": notification.testId || notification.ID
    }, _react.default.createElement(_styles.SnackElement, {
      style: {
        borderLeftColor: this.selectColor(notification.category, notification.isRead)
      },
      onMouseLeave: () => onMouseLeave(),
      onMouseEnter: () => onMouseEnter()
    }, _react.default.createElement(_styles.Icon, null, _react.default.createElement(IconComponent, {
      fill: this.selectColor(notification.category)
    })), _react.default.createElement(_styles.Content, null, notification.text && _react.default.createElement(_styles.Text, null, notification.text), _react.default.createElement(_styles.ActionsContainer, null, notification.actions && !!notification.actions.length && _react.default.createElement(_styles.Actions, null, notification.actions.map((action, idx) => _react.default.createElement(_styles.Button, {
      key: idx,
      mode: theme.name === _constants.THEMES.mds ? 'secondary' : 'link',
      title: action.title,
      onClick: () => {
        if (this.props.handleNotification) {
          this.props.handleNotification(undefined, this.props.notification);
        }
        if (action.callback) {
          this.hideAndRead();
          action.callback();
        } else {
          this.hideAndRead(() => {
            window.open(action.extra.uri, selectLinkTarget(action.extra.newTab) ? '_blank' : '_self');
          });
        }
      }
    }))), this.props.notification.createdOn && _react.default.createElement(_styles.Timestamp, null, (0, _format.default)((0, _isDate.default)(notification.createdOn) ? notification.createdOn : (0, _parseISO.default)(notification.createdOn), this.props.localeData.dateFormat)))), _react.default.createElement(_styles.ButtonBox, {
      empty: notification.isRead,
      onClick: this.hide,
      title: this.selectActionTitle(notification.isRead)
    }, selectActionIcon(notification.isRead))));
  }
}
Snack.defaultProps = {
  isFadeIn: true,
  isFadeOut: false,
  onMouseEnter: () => {},
  onMouseLeave: () => {}
};
var _default = exports.default = (0, _styledComponents.withTheme)(Snack);